import { Component, DoCheck } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormViewService } from '@xilo-mono/form-contracts';

@Component({
  selector: 'xilo-mono-form-viewer-question-group',
  templateUrl: './question-group.component.html',
  styleUrls: ['./question-group.component.scss'],
})
export class QuestionGroupTypeComponent extends FieldType implements DoCheck {
  constructor(private formViewService: FormViewService) {
    super();
  }

  // version2Form : version two form are used for the address-v2-component and customer-forms only
  get version2Form(){
    return this.field.fieldGroup.some(i => i.templateOptions?.version == 2 && i.templateOptions?.className == 'xilo-input')
  }

  ngDoCheck() {
    this.formViewService.changeQuestionGroupState({
      valid: this.formControl?.valid,
    });
  }
}
